import { useState, useEffect } from "react";
import { api } from "../api/client";

/**
 * Persönliche Notizen. Wiederverwendbares Widget statt eigener Seite -
 * wird in Detailseiten eingebettet (Prinzip "keine neuen Routen ohne Not").
 *
 * WICHTIG (siehe Backend, routers/notizen.py): diese Notizen sind PRIVAT -
 * niemand sonst, auch kein Admin, sieht sie.
 */
export default function PersoenlicheNotizen({ objektTyp, objektId }) {
  const [notizen, setNotizen] = useState(null);
  const [neuerText, setNeuerText] = useState("");
  const [bearbeitungId, setBearbeitungId] = useState(null);
  const [bearbeitungText, setBearbeitungText] = useState("");

  const laden = () => api.getNotizen(objektTyp, objektId).then(setNotizen).catch(() => setNotizen([]));
  useEffect(() => { laden(); }, [objektTyp, objektId]);

  if (notizen === null) return null;

  const anlegen = async () => {
    if (!neuerText.trim()) return;
    await api.createNotiz(objektTyp, objektId, neuerText.trim());
    setNeuerText("");
    laden();
  };

  const speichern = async (id) => {
    await api.updateNotiz(id, bearbeitungText);
    setBearbeitungId(null);
    laden();
  };

  const loeschen = async (id) => {
    if (!window.confirm("Notiz löschen?")) return;
    await api.deleteNotiz(id);
    laden();
  };

  return (
    <div className="card" style={{ padding: 20, marginTop: 16 }}>
      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Meine Notizen</h2>
      <div style={{ fontSize: 11, color: "#999", marginBottom: 12 }}>Nur für dich sichtbar, auch nicht für Administratoren.</div>

      {notizen.map(n => (
        <div key={n.id} style={{ padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
          {bearbeitungId === n.id ? (
            <>
              <textarea className="form-control" rows={2} value={bearbeitungText}
                        onChange={e => setBearbeitungText(e.target.value)} style={{ marginBottom: 6 }} />
              <button className="btn btn-primary btn-sm" onClick={() => speichern(n.id)}>Speichern</button>{" "}
              <button className="btn btn-secondary btn-sm" onClick={() => setBearbeitungId(null)}>Abbrechen</button>
            </>
          ) : (
            <>
              <div style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{n.text}</div>
              <div style={{ fontSize: 10, color: "#aaa", marginTop: 4 }}>
                {n.updated_at && new Date(n.updated_at).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                {" · "}
                <button onClick={() => { setBearbeitungId(n.id); setBearbeitungText(n.text); }}
                        style={{ background: "none", border: "none", color: "var(--info)", cursor: "pointer", fontSize: 10, padding: 0 }}>Bearbeiten</button>
                {" · "}
                <button onClick={() => loeschen(n.id)}
                        style={{ background: "none", border: "none", color: "var(--danger)", cursor: "pointer", fontSize: 10, padding: 0 }}>Löschen</button>
              </div>
            </>
          )}
        </div>
      ))}

      <textarea className="form-control" rows={2} placeholder="Neue Notiz…" value={neuerText}
                onChange={e => setNeuerText(e.target.value)} style={{ marginTop: notizen.length ? 12 : 0, marginBottom: 8 }} />
      <button className="btn btn-secondary btn-sm" onClick={anlegen}>Notiz hinzufügen</button>
    </div>
  );
}
